
import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from '../../components/SubNavBar/SubNavBar';
import AddWallet from './AddWallet';



function action({ store, params, query }) {
  const title = store.getState().siteSettings?.data?.siteTitle
  const description = store.getState().siteSettings?.data?.metaDescription;
  let isAuthenticated = store.getState().runtime.isAuthenticated, orderId, bookingId;

  if ("type" in query && encodeURI(query?.type)) {
    orderId = query?.type;
  }

  if ("tracking" in query && encodeURI(query?.tracking)) {
    bookingId = query?.tracking;
  }

  if (!isAuthenticated) {
    return { redirect: '/' }
  }

  return {
    title,
    description,
    component: (
      <Layout>
        <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
          {isAuthenticated && <SubNavBar />}
          <AddWallet orderId={orderId} bookingId={bookingId}/>
        </div>
      </Layout>
    ),
  };
}

export default action;
